import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { SlideFrame } from '../SlideFrame';
import { rewards } from '../../data/deckContent';
export function PromiseSlide() {
  const reduced = useReducedMotion();
  return <SlideFrame eyebrow="The promise" index={3} data-id="element-148" data-mp="zzi53skayqwp">
      <div className="grid grid-cols-[1.05fr_0.95fr] items-center gap-[6%]" data-id="element-149" data-mp="142etjzwixh8k">
        <div data-id="element-150" data-mp="140bt0lxqw5pl">
          <h2 className="text-[clamp(28px,4.2vw,74px)] font-semibold leading-[1.05] tracking-tight text-white" data-id="element-151" data-mp="191rh6mv7ysc7">
            Give us a little time.
            <br data-id="element-152" data-mp="1dzjdru6t72mq" />
            <span className="text-[color:var(--sv-green)]" data-id="element-153" data-mp="1dz00iqs3t2f1">
              We’ll give you more back.
            </span>
          </h2>
          <div className="mt-[3.5vh] inline-flex items-center gap-[1vw] rounded-full border border-[color:var(--sv-green)]/45 bg-[color:var(--sv-green)]/10 px-[1.6vw] py-[1.2vh]" data-id="element-154" data-mp="1nqe4bar38odz">
            <span className="text-[clamp(11px,1.15vw,22px)] font-medium tracking-wide text-white" data-id="element-155" data-mp="1rqeg0nmsylhc">
              Low effort
            </span>
            <span className="text-[clamp(11px,1.15vw,22px)] text-[color:var(--sv-green)]" data-id="element-156" data-mp="2cxz7w6odjjrf">
              →
            </span>
            <span className="text-[clamp(11px,1.15vw,22px)] font-medium tracking-wide text-white" data-id="element-157" data-mp="28uki4oamvp0s">
              High reward
            </span>
          </div>
        </div>

        <div className="rounded-[1.6vw] border border-white/10 bg-white/[0.03] p-[2.2vw]" data-id="element-158" data-mp="1yyr4f1l6hphf">
          <p className="text-[clamp(10px,0.9vw,17px)] uppercase tracking-[0.3em] text-white/40" data-id="element-159" data-mp="2wlznkpxpimg9">
            A few seconds of attention should deliver
          </p>
          <ul className="mt-[2.4vh] grid grid-cols-2 gap-[1.4vh_1.2vw]" data-id="element-160" data-mp="2rozioiclfpqq">
            {rewards.map((reward, i) => <motion.li key={reward} initial={reduced ? false : {
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.35,
            delay: 0.05 * i,
            ease: 'easeOut'
          }} className="flex items-baseline gap-[0.7vw] text-[clamp(12px,1.3vw,25px)] font-light text-white/85" data-id="element-161" data-mp="2hx3fisvnh9fn" data-mpi={i}>
                <span className="text-[color:var(--sv-green)]" data-id="element-162" data-mp="18qbe9qvfv997">—</span>
                {reward}
              </motion.li>)}
          </ul>
        </div>
      </div>
    </SlideFrame>;
}